import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { SearchBar } from './SearchBar';
import { Settings, ViewGrid, LogOut, ShieldCheck, CreditCard } from 'iconoir-react';

interface NavbarProps {
  contextRole?: 'admin' | 'editor' | 'visitor' | null;
  boardName?: string;
}

export const Navbar: React.FC<NavbarProps> = ({ contextRole = null, boardName }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    if (window.confirm('Voulez-vous vraiment vous déconnecter ?')) {
      await logout();
    }
  };

  const isDashboardPage = location.pathname === '/dashboard';

  const getRoleBadge = (role: string) => {
    const badges = {
      super_admin: { label: 'Super Admin', color: '#9b59b6' },
      admin: { label: 'Administrateur', color: '#e74c3c' },
      editor: { label: 'Éditeur', color: '#3498db' },
      visitor: { label: 'Visiteur', color: '#95a5a6' },
    };
    return badges[role as keyof typeof badges] || badges.visitor;
  };

  if (!user) return null;

  // Déterminer quel rôle afficher selon le contexte
  const displayRole = contextRole || (user.role === 'super_admin' ? 'super_admin' : null);
  const badge = displayRole ? getRoleBadge(displayRole) : null;

  return (
    <div className="navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          <SearchBar />
        </div>
        <div className="navbar-center">
          <div className="navbar-brand">
            <a href='https://ventilio.fr'><img src="/assets/ventilio.png" alt="Ventilio" style={{ height: '40px' }} /></a>
          </div>
        </div>
        <div className="navbar-right">
          <button 
            className="btn btn-nav"
            onClick={() => navigate(isDashboardPage ? '/' : '/dashboard')}
          >
            {isDashboardPage ? (
              <>
                <ViewGrid width={18} height={18} strokeWidth={2} />
                <span>Tableaux</span>
              </>
            ) : (
              <>
                <Settings width={18} height={18} strokeWidth={2} />
                <span>Dashboard</span>
              </>
            )}
          </button>
          <button 
            className="btn btn-nav"
            onClick={() => navigate('/account')}
            title="Gérer mon abonnement et mes documents"
          >
            <CreditCard width={18} height={18} strokeWidth={2} />
            <span>Mon compte</span>
          </button>
          {user.role === 'super_admin' && (
            <button 
              className="btn btn-nav"
              onClick={() => navigate('/admin/saas')}
              style={{ 
                backgroundColor: '#9b59b6',
                color: 'white',
                border: '2px solid #8e44ad'
              }}
              title="Interface d'administration SaaS"
            >
              <ShieldCheck width={18} height={18} strokeWidth={2} />
              <span>Admin SaaS</span>
            </button>
          )}
          <div className="user-info" onClick={() => navigate('/account')} style={{ cursor: 'pointer' }} title="Gestion du compte">
            <div className="user-avatar">
              {user.avatar_url ? (
                <img src={user.avatar_url} alt={user.name} className="user-avatar-image" />
              ) : (
                user.name.charAt(0).toUpperCase()
              )}
            </div>
            <div className="user-details">
              <div className="user-name">{user.name}</div>
              {badge && (
                <div className="user-role" style={{ backgroundColor: badge.color }}>
                  {badge.label}
                </div>
              )}
            </div>
          </div>
          <button className="btn btn-logout" onClick={handleLogout} title="Déconnexion">
            <LogOut width={18} height={18} strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
};
